import { render, staticRenderFns } from "./inviteProxyRegApply.vue?vue&type=template&id=61b70484&"
import script from "./inviteProxyRegApply.vue?vue&type=script&lang=js&"
export * from "./inviteProxyRegApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports